import { useState } from 'react';
import { BaseAccordionProps } from './types';

export const useBaseAccordion = (props: BaseAccordionProps) => {
  const [internalExpanded, setInternalExpanded] = useState(
    props.defaultExpanded || false
  );

  const isExpanded =
    props.expanded !== undefined ? props.expanded : internalExpanded;

  const handleToggle = () => {
    if (props.onChange) {
      props.onChange();
    } else {
      setInternalExpanded(!internalExpanded);
    }
  };

  return {
    isExpanded,
    handleToggle,
  };
};
